import { useEffect, useState } from "react";
import { PDFDocument } from "pdf-lib";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

// configure pdf.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export const useCroppedSecondPage = (pdfUrl, padding = { top: 20, bottom: 40 }) => {
    const [croppedUrl, setCroppedUrl] = useState(null);

    useEffect(() => {
        const cropPdf = async () => {
            if (!pdfUrl) {
                setCroppedUrl(null)
                return;
            }
            try {
                const pdfBytes = await fetch(pdfUrl).then((res) => res.arrayBuffer());
                const pdfDoc = await PDFDocument.load(pdfBytes);

                const pdf = await pdfjsLib.getDocument({ data: pdfBytes }).promise;

                for (let i = 0;i < pdfDoc.getPageCount();i++) {
                    const page = await pdf.getPage(i + 1); // pdf.js is 1-based
                    const textContent = await page.getTextContent();

                    if (!textContent.items.length) continue; // skip blank pages

                    let minY = Infinity;
                    let maxY = 0;

                    textContent.items.forEach((item) => {
                        const y = item.transform[5];
                        const height = item.height || 12;
                        minY = Math.min(minY, y);
                        maxY = Math.max(maxY, y + height);
                    });

                    const libPage = pdfDoc.getPages()[i];
                    const { width } = libPage.getSize();

                    const contentHeight =
                        maxY - minY + padding.top + padding.bottom;
                    const yStart = Math.max(minY - padding.top, 0);

                    libPage.setMediaBox(0, yStart, width, contentHeight);
                }

                const croppedPdfBytes = await pdfDoc.save();
                const blob = new Blob([croppedPdfBytes], { type: "application/pdf" });
                setCroppedUrl(URL.createObjectURL(blob));
            } catch (err) {
                console.error("Cropping failed:", err);
                setCroppedUrl(pdfUrl); // fallback to original
            }
        };

        cropPdf();
    }, [pdfUrl, padding.top, padding.bottom]);

    return croppedUrl;
};
